import React, { useEffect } from 'react';
import ReactModal, { Props as ModalProps } from 'react-modal';
import cm from 'classnames';

import { ReactComponent as CrossIcon } from 'assets/ui/cross.svg';
import { resetTooltips } from 'components/UI/tooltip/tooltip-lock';

import styles from './_modal.module.scss';

interface Props extends ModalProps {
  children: React.ReactNode;
  className?: string;
}

ReactModal.setAppElement(document.createElement('div'));

export const Modal = ({ className, children, isOpen, onRequestClose, ...rest }: Props) => {
  const finalClassName = [styles.Content];
  if (className) finalClassName.push(className);

  useEffect(() => {
    if (isOpen) resetTooltips();
  }, [isOpen]);

  return (
    <ReactModal
      className={cm(finalClassName)}
      overlayClassName={styles.Overlay}
      bodyOpenClassName={styles.Body}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      {...rest}
    >
      <div className={styles.CloseBtn} onClick={onRequestClose}>
        <CrossIcon />
      </div>
      {children}
    </ReactModal>
  );
};
